import React from "react";
import Colors from "../../../themes/Colors";
import CustomButton from "../../../components/CustomButton/CustomButton";
import { FORMATOS_ADJUNTOS_PERMITIDOS } from "../utils/IngresoConstant";
import {
  UploadOutlined,
  DeleteOutlined,
  EyeOutlined,
  LoadingOutlined,
} from "@ant-design/icons";

const DocumentUploadRow = ({
  docKey,
  label,
  required,
  docInfo,
  isUploading,
  COLOR_PRINCIPAL,
  COLOR_SECUNDARIO,
  LETRA_PRINCIPAL,
  onUpload,
  onRemove,
  onView,
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "15px 20px",
        backgroundColor: Colors.white,
        border: "1px solid #d9d9d9",
        borderRadius: "8px",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        <span style={{ fontWeight: "bold", fontSize: "15px", fontFamily: LETRA_PRINCIPAL }}>
          {label}{" "}
          {required && (
            <span style={{ color: Colors.huDanger || "red" }}>
              *
            </span>
          )}
        </span>
        {docInfo && (
          <span
            style={{ fontSize: "13px", color: Colors.huGray, fontFamily: LETRA_PRINCIPAL }}
          >
            {docInfo.fileName}
          </span>
        )}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {isUploading ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              color: COLOR_PRINCIPAL,
              fontFamily: LETRA_PRINCIPAL,
            }}
          >
            <LoadingOutlined style={{ fontSize: 20 }} spin />
            <span style={{ fontSize: "14px" }}>Subiendo...</span>
          </div>
        ) : docInfo ? (
          <>
            <CustomButton
              label={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <EyeOutlined />
                  <span>Visualizar</span>
                </div>
              }
              onClick={onView}
              bgColor={Colors.white}
              textColor={COLOR_PRINCIPAL}
              border={`1px solid ${COLOR_PRINCIPAL}`}
              width="120px"
              height="35px"
              fontSize="13px"
            />
            <CustomButton
              label={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <DeleteOutlined />
                  <span>Eliminar</span>
                </div>
              }
              onClick={onRemove}
              bgColor={Colors.white}
              textColor={Colors.huDanger || "red"}
              border={`1px solid ${Colors.huDanger || "red"}`}
              width="110px"
              height="35px"
              fontSize="13px"
            />
          </>
        ) : (
          <>
            <input
              type="file"
              id={`file-input-${docKey}`}
              onChange={onUpload}
              accept={FORMATOS_ADJUNTOS_PERMITIDOS}
              style={{ display: "none" }}
            />
            <CustomButton
              label={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <UploadOutlined />
                  <span>Adjuntar archivo</span>
                </div>
              }
              onClick={() => {
                const element = document.getElementById(`file-input-${docKey}`);
                if (element) {
                  element.click();
                }
              }}
              bgColor={COLOR_SECUNDARIO}
              textColor={Colors.white}
              width="160px"
              height="35px"
              fontSize="13px"
              weight="bold"
            />
          </>
        )}
      </div>
    </div>
  );
};

export default DocumentUploadRow;
